module.exports = __webpack_public_path__ + "static/media/iyizico-logo.1ace4fe8.svg";